import * as React from "react";
const SvgEditFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.97 2.293a1 1 0 0 0-1.413 0l-2.083 2.082L19.8 8.701l2.092-2.064a1 1 0 0 0 .004-1.419zm-.594 7.812L14.06 5.79 3.414 16.435a1 1 0 0 0-.273.511l-.707 3.535a1 1 0 0 0 1.176 1.177l3.536-.707a1 1 0 0 0 .506-.268z", clipRule: "evenodd" }));
export default SvgEditFill;
